import React, { useState } from 'react';
import '../../../../../../../Stylesheets/Dashboard/Tabs/Labor/WorkerPaymentHistoryModal.css';
import { FaSortAmountDown, FaCalendarAlt } from 'react-icons/fa';
import { format } from 'date-fns';




const PaymentHistoryModal = ({ payments, onClose }) => {
    const [sortBy, setSortBy] = useState('date'); // 'date' or 'amount'
    const [currentPage, setCurrentPage] = useState(1);
    const paymentsPerPage = 5;

    const sortedPayments = [...payments].sort((a, b) => {
        if (sortBy === 'date') {
            return new Date(b.date) - new Date(a.date);
        } else {
            return b.amount - a.amount;
        }
    });

    const indexOfLast = currentPage * paymentsPerPage;
    const indexOfFirst = indexOfLast - paymentsPerPage;
    const currentPayments = sortedPayments.slice(indexOfFirst, indexOfLast);

    const totalPages = Math.ceil(payments.length / paymentsPerPage);

    return (
        <div className="worker-drawer-modal-overlay">
            <div className="worker-drawer-modal">
                <div className="worker-drawer-modal-header">
                    <h3>Payment History</h3>
                    <button onClick={onClose}>X</button>
                </div>

                <div className="worker-drawer-modal-sort">
                    <button onClick={() => setSortBy('date')}>
                        <FaCalendarAlt /> Sort by Date
                    </button>
                    <button onClick={() => setSortBy('amount')}>
                        <FaSortAmountDown /> Sort by Amount
                    </button>
                </div>

                <div className="worker-drawer-modal-content">
                    {currentPayments.length === 0 ? (
                        <p>No payments available.</p>
                    ) : (
                        <table className="worker-drawer-modal-table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Amount (₹)</th>
                                    <th>Mode</th>
                                    <th>Note</th>
                                    <th>Receipt</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentPayments.map((payment, index) => (
                                    <tr key={index}>
                                        <td>{format(new Date(payment.date), 'dd MMM yyyy')}</td>
                                        <td>₹ {payment.amount}</td>
                                        <td>{payment.mode || '—'}</td>
                                        <td>{payment.note || '—'}</td>
                                        <td>
                                            {payment.receipt ? (
                                                <a
                                                    href={payment.receipt}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="worker-drawer-receipt-link"
                                                >
                                                    View
                                                </a>
                                            ) : (
                                                '—'
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    )}
                </div>

                {totalPages > 1 && (
                    <div className="worker-drawer-modal-pagination">
                        <button disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)}>
                            Previous
                        </button>
                        <span>Page {currentPage} of {totalPages}</span>
                        <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(prev => prev + 1)}>
                            Next
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaymentHistoryModal;
